module.exports = __webpack_public_path__ + "static/media/peikko-group-logo.2dec9f09.svg";